import { twMerge } from "tailwind-merge";

interface RuleBookType {
  title?: string;
  channel: string;
  timing: string;
  template?: string;
  onClick?: (event: Event) => void;
  className?: string;
}

const RuleEvent = ({
  title,
  channel,
  timing,
  template,
  className,
}: RuleBookType) => {
  return (
    <div
      className={twMerge(
        "box w-fit min-w-[12rem] max-w-[18rem] p-2 flex flex-col mx-auto gap-3",
        className,
      )}
    >
      {title && <div className="font-bold py-2">{title}</div>}
      <div className="flex gap-2 items-center">
        <span className="min-w-44 text-left">Method</span>
        <span className="font-semibold">{channel}</span>
      </div>
      <div className="flex gap-2 items-center">
        <span className="min-w-44 text-left">Time Delay</span>
        <span className="font-semibold">{timing}</span>
      </div>
      {/* {template && channel !== 'Phone' && (
        <div className='flex gap-2 items-center'>
          <span className='min-w-44 text-left'>Template</span>
          <span className='font-semibold'>{template}</span>
        </div>
      )} */}
    </div>
  );
};

export default RuleEvent;